import React from 'react';
import { List, ListItem } from 'material-ui/List';
import { CardText } from 'material-ui/Card';
import { Link } from 'react-router';
import { withRouter } from 'react-router';
import Button from 'material-ui/RaisedButton';

const RecentlyUpdatedItemListItem = (props) => {
  return (
    <ListItem onClick={props.onClick} primaryText={props.title} rightIcon={<div>{props.category}</div>} />
  )
}

class RecentlyUpdatedItemsList extends React.Component {
  render() {
    let props = this.props;
    let items = props.items.sort((a, b) => {
      return a.updatedAt > b.updatedAt
    }).reverse().slice(0, props.numItems);
    if (items.length > 0) {
      return (
        <List>
          {items.map((item) => <RecentlyUpdatedItemListItem onClick={this._onClick.bind(this, item.id)} key={item.id} title={item.id + ": " + item.title} />)}
          <CardText><Button label="See full list" containerElement={<Link to={props.rootUrl} />} /></CardText>
        </List>
      );
    } else {
      return (<CardText>None</CardText>)
    }
  }

  _onClick(id) {
    this.props.router.push((this.props.editUrl || this.props.rootUrl) + "/" + id);
  }
}

export default withRouter(RecentlyUpdatedItemsList);
